module.exports = __webpack_public_path__ + "img/hr-product-grid-bg-top-large@2x.a4d72495.png";